import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF } from 'ngx-image-gallery';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { MarketplaceService } from 'src/app/services/marketplace/marketplace';
import { ModalService } from '../modal.service';
import { CoreTranslateService } from 'src/app/services/utilitys/utilitys.service';

@Component({
  selector: 'app-modal-market-product-edit',
  templateUrl: './modal-market-product-edit.component.html',
  styleUrls: ['./modal-market-product-edit.component.scss']
})
export class ModalMarketProductEditComponent implements OnInit {

  @ViewChild('marketProductEditModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };

  @ViewChild(NgxImageGalleryComponent, {static: true}) ngxImageGallery: NgxImageGalleryComponent;
  images: GALLERY_IMAGE[] = [];
  conf: GALLERY_CONF = {
    imageBorderRadius: '3px',
    imageOffset: '20px',
    showDeleteControl: false,
    showCloseControl: true,
    showExtUrlControl: true,
    showImageTitle: true,
    showThumbnails: true,
    closeOnEsc: true,
    reactToKeyboard: true,
    reactToMouseWheel: true,
    reactToRightClick: false,
    thumbnailSize: 30,
    backdropColor: 'rgba(13,13,14,0.85)',
    inline: false,
    showArrows: true,
    imagePointer: true
  };

  title = "";
  store: any = {};
  callback: Function;
  productModel: any = {};
  errorMsg = '';
  categorys: any = [];
  product: any = {};
  maxImage = 10;
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private api: ApiService,
    private mkp: MarketplaceService,
    private ngxLoading: NgxUiLoaderService,
    private coreTranslate: CoreTranslateService
  ) { }

  ngOnInit() {
    this.modalServ.onMarketProductEdit.subscribe(req => {
      this.title = this.coreTranslate.getWord('PRODUCT.EDIT_PRODUCT_INFORMATION');
      this.productModel = {};
      this.product = req.product;
      this.getMyProduct(req.product.ProductID);
      this.getMyStore(this.product.MerchantID);
      this.callback = req.callback;
      this.getMarketPlaceCategory();
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onMarketProductEditHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  async getMyStore(id: any) {
    this.store = await this.mkp.getMerchantInfo(id);
  }

  async getMyProduct(id: any) {
    var model = await this.getProductInfo();
    this.productModel.imageProducts = model.ProductImages;
    this.productModel.prod_name = model.Name;
    this.productModel.prod_detail = model.Detail;
    this.productModel.prod_cat = model.Category;
    this.productModel.prod_price = model.Price;
    this.productModel.merchant_id = model.MerchantID;
    this.productModel.is_onshelf = model.IsOnshelf;
    this.productModel.product_id = model.ProductID;
  }

  addProduct() {
    if(!this.validation()) return;
    this.ngxLoading.start();
    this.api.marketPlaceCrateProduct(this.productModel).subscribe(res => {
      if (res.Code == 200) {
        this.callback({status: 'success'});
      } else {
        this.callback({status: 'fail'});
      }
      this.hide();
      this.ngxLoading.stopAll();
    }, err => {
      console.error(err);
      this.callback({status: 'fail'});
      this.ngxLoading.stopAll();
    });
  }

  validation() {
    this.productModel.merchant_id = this.store.MerchantId;
    if (Object.keys(this.productModel).length === 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_FILL_ALL_INFORMATION');
      return false;
    } else if(!this.productModel.hasOwnProperty('imageProducts') || this.productModel.imageProducts.length < 1) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_AT_LEAST_1_PRODUCT_PICTURE');
      return false;
    } else if (!this.productModel.prod_name) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_NAME');
      return false;
    } else if (!this.productModel.prod_cat) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_TYPE');
      return false;
    } else if ((this.productModel.prod_price || this.productModel.prod_price === 0 ? false : true) || this.productModel.prod_price < 0) {
      this.errorMsg = this.coreTranslate.getWord('PRODUCT.PLEASE_SPECIFY_PRODUCT_PRICE');
      return false;
    }

    return true;
  }

  fileChange(event: any) {
    // this.hide();
    this.modalServ.onImageCapture.emit({image: event, callback: (res)=>{
      if(res) {
        if(!this.productModel.hasOwnProperty('imageProducts')) {
          this.productModel.imageProducts = [];
        }
        
        this.productModel.imageProducts.push({Url: res, IsDefault: false});
      }
    }});
  }

  validateMoney(value: any) {
    let pattern = /[0-9]/g;
    let w = pattern.test(value.value);
    if(!w) {
      value.value = null;
    }
  }

  getMarketPlaceCategory() {
    this.api.getMarketPlaceCategory(false).subscribe(res => {
      if (res.Code == 200) {
        this.categorys = res.Results;
      } else {
        console.error(res);
      }
    }, err => {
      console.error(err);
    });
  }

  openEditImage(index: any) {
    let model: any = {};
    if(this.productModel.imageProducts[index].Url.indexOf('http') > -1) {
      model.imgUrl = this.productModel.imageProducts[index].Url;
    } else{
      model.imgFile = this.productModel.imageProducts[index].Url;
    }
    
    model.callback = (res)=>{
      if(res){
        this.productModel.imageProducts[index] = { Url: res, IsDefault: this.productModel.imageProducts[index].IsDefault };
        // this.modalRef = this.modalService.show(this.modal, this.configmodal);
      }
    };

    this.modalServ.onImageCapture.emit(model);
  }

  viewImage(index: any) {
    this.modalServ.onImageViewer.emit({image: this.productModel.imageProducts[index].Url});
  }

  setImageDefulte(img: any) {
    this.productModel.imageProducts.forEach((g: any) => {
      g.IsDefault = false;
    });
    img.IsDefault = true;
  }

  getProductInfo(): Promise<any> {
    return new Promise((resovle) => {
      this.api.getMarketPlaceProductInfo(this.product.ProductID).subscribe(res => {
        if (res.Code == 200) {
          resovle(res.Results);
        } else {
          this.ngxLoading.stopAll();
          console.error(res);
          resovle('');
        }
      }, err => {
        console.error(err);
        this.ngxLoading.stopAll();
        resovle('');
      });
    });
  }

  async editProduct() {
    if (!this.validation()) return;
    this.modalServ.onConfirm.emit({title: this.coreTranslate.getWord('PRODUCT.CONFIRM'), content: this.coreTranslate.getWord('PRODUCT.CONFIRM_EDIT_PRODUCT'), callback: res => {
      if(res.status == 'confirm') {
        this.onEditProduct();
      }
    }});
  }

  onEditProduct() {
    this.ngxLoading.start();
    for(let i = 0; i < this.productModel.imageProducts.length; i++){
      if('Id' in this.productModel.imageProducts[i] && this.productModel.imageProducts[i].Url.indexOf('http') == -1){
        delete this.productModel.imageProducts[i]['Id'];
        this.productModel.imageProducts.push(this.productModel.imageProducts[i]);
        this.productModel.imageProducts.splice(i, 1);
      }
    }
    
    this.api.marketPlaceProductUpdate(this.productModel).subscribe(res => {
      if(res.Code == 200) {
        this.callback({status: 'success'});
      } else {
        console.error(res);
        this.callback({status: 'danger'});
      }
      this.ngxLoading.stopAll();
      this.hide();
    }, err => {
      console.error(err);
      this.callback({status: 'danger'});
      this.hide();
      this.ngxLoading.stopAll();
    });
  }

  removeImageProduct(index: any) {
    if (this.productModel.imageProducts[index].hasOwnProperty('Id')) {
      if(!this.productModel.hasOwnProperty('imageProductDelete')) {
        this.productModel.imageProductDelete = [];
      }
      this.productModel.imageProductDelete.push(this.productModel.imageProducts[index].Id);
    } 
    this.productModel.imageProducts.splice(index, 1);
  }

  showInfo() {
    this.modalServ.onInfo.emit({title: this.coreTranslate.getWord('PRODUCT.CONDITIONS'), content: '*' + this.coreTranslate.getWord('PRODUCT.60_DAYS_REMAIN_PRODUCT'), callback: res=>{}});
  }

  deleteProduct() {
    this.modalServ.onConfirm.emit({title: this.coreTranslate.getWord('PRODUCT.CONFIRM'), content: this.coreTranslate.getWord('PRODUCT.CONFIRM_DELETE_PRODUCT'), callback: res => {
      if(res.status == 'confirm') {
        this.onDeleteProduct();
      }
    }});
  }

  onDeleteProduct() {
    this.ngxLoading.start();
    this.api.marketPlaceProductDelete(this.productModel.product_id).subscribe(res => {
      this.ngxLoading.stopAll();
      if(res.Code == 200) {
        this.modalServ.onInfo.emit({title: this.coreTranslate.getWord('PRODUCT.SUCCESSFULLY'), content: this.coreTranslate.getWord('PRODUCT.PRODUCT_SUCCESSFULLY_DELETED'), callback: res=> {}});
        this.callback({status: 'delete-success'});
      }
      this.hide();
      this.ngxLoading.stopAll();
    }, err => {
      console.error(err);
    });
  }

}
